'use strict';

// Contants Includes
const carouselConfig = require('../config/constants/carousel');

/**
 * @function createProductDetailsCarousel
 * @param {string} element - Element to transform into a Carousel.
 * @param {Object} carouselConfig - Configuration object
 * @description creates a Slick Carousel on Product Details
 */
var createProductDetailsCarousel = function (element) {
    const $element = $(element).not('.slick-initialized');

    if ($element.length) {
        $element.slick(carouselConfig.productDetails);
    }
};

/**
 * @function createInspirationsCarousel
 * @param {string} element - Element to transform into a Carousel.
 * @param {Object} carouselOptions - Dinamic options for the carousel
 * @param {Object} carouselConfig - Configuration object
 * @description creates a Slick Carousel for Page Designer Carousels
 */
var createInspirationsCarousel = function (element, carouselOptions) {
    const $element = $(element).not('.slick-initialized');
    var configs = carouselConfig.inspirations;

    configs.arrows = carouselOptions.arrows;
    configs.dots = carouselOptions.dots;

    if ($element.length) {
        $element.slick(configs);
    }
};

/**
 * @function createRecommendationsCarousel
 * @param {string} element - Element to transform into a Carousel.
 * @param {Object} carouselConfig - Configuration object
 * @description creates a Slick Carousel on Product Details
 */
var createRecommendationsCarousel = function (element) {
    const $element = $(element).not('.slick-initialized');

    if ($element.length) {
        $element.slick(carouselConfig.recommendations);
    }
};

/**
 * @function createGenericCarousel
 * @param {string} element - Element to transform into a Carousel.
 * @param {Object} carouselOptions - Dinamic options for the carousel
 * @param {Object} carouselConfig - Configuration object
 * @description creates a Slick Carousel for Page Designer Carousels
 */
var createGenericCarousel = function (element, carouselOptions) {
    const $element = $(element).not('.slick-initialized');
    var configs = carouselConfig.generic;

    configs.slidesToShow = carouselOptions.slidesToShow * 2;
    configs.slidesToScroll = carouselOptions.slidesToScroll * 2;
    configs.responsive = [
        {
            breakpoint: 728,
            settings: {
                slidesToShow: carouselOptions.slidesToShow,
                slidesToScroll: carouselOptions.slidesToScroll
            }
        }
    ];
    configs.arrows = carouselOptions.arrows;
    configs.dots = carouselOptions.dots;

    if ($element.length) {
        $element.slick(configs);
    }
};

module.exports = {
    createProductDetailsCarousel: createProductDetailsCarousel,
    createInspirationsCarousel: createInspirationsCarousel,
    createGenericCarousel: createGenericCarousel,
    createRecommendationsCarousel: createRecommendationsCarousel
};
